import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClientGenerateOTPUseCase extends BaseUseCase {
    constructor(loginFLowRepo) {
        super();
        this.loginFLowRepo = loginFLowRepo;
    }
    async fetchResult(data) {
        return await this.loginFLowRepo.clientGenerateOTP(data);
    }
}
export default ClientGenerateOTPUseCase;
